"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var OTHER_REASON = "Other",
    _default = {
  REJECT_VERSION: ["Audio error", "Branding", "Brief not followed", "Did not check export", "Invalid upload", "Major changes", "Minor tweaks", "Missing captions", "No editor comments", "Spelling"],
  OTHER_REASON: OTHER_REASON,
  SUBMIT_CHANGES: ["I have some small adjustments", "Shootsta missed some things", "I would like to change the video concept", OTHER_REASON]
};
exports["default"] = _default;